import { Roles } from 'config'

//import AdminPage from 'views/AdminPage/AdminPage.js'
import DashboardPage from 'views/DashboardPage/DashboardPage.js'
import StatsPage from 'views/StatsPage/StatsPage.js'
import LedgerPage from 'views/LedgerPage/LedgerPage.js'
import TaskAccountingPage from 'views/TaskAccountingPage/TaskAccountingPage.js'
import ReportingPage from 'views/ReportingPage/ReportingPage.js'
import SettingsPage from 'views/SettingsPage/SettingsPage.js'
import HelpCenter from 'views/HelpCenterPage/HelpCenter';
import CustomersPage from 'views/CustomersPage/CustomersPage';
import OperationsPage from 'views/OperationsPage/OperationsPage';

import DashboardIcon from '@material-ui/icons/Dashboard';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import PersonIcon from '@material-ui/icons/Person';
import BarChartIcon from '@material-ui/icons/BarChart';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SettingsIcon from '@material-ui/icons/Settings';
import HelpIcon from '@material-ui/icons/Help';

export default [
	{
		component: DashboardPage,
		path: '/',
		title: 'Dashboard',
		exact: true,
		icon: <DashboardIcon />,
	},
	{
		component: StatsPage,
		path: '/stats',
		title: 'Stats',
		exact: true,
		icon: <BarChartIcon />,
	},
	{
		component: LedgerPage,
		path: '/ledger',
		title: 'Ledger',
		exact: true,
		icon: <AccountBalanceWalletIcon />,
	},
	/*{
	component: TaskAccountingPage,
	path: '/taskaccounting',
	title: 'TaskAccounting',
	exact: true,
},*/
	{
		component: ReportingPage,
		path: '/reporting',
		title: 'Reporting',
		exact: true,
		icon: <AssignmentIcon />,
	},
	{
		component: CustomersPage,
		path: '/customers',
		title: 'Customers',
		exact: true,
		icon: <PersonIcon />,
	},
	{
		component: OperationsPage,
		path: '/operations',
		title: 'Operations',
		exact: true,
		icon: <ImportantDevicesIcon />,
		permission: ['Normal'],
	},
	{
		component: HelpCenter,
		path: '/help',
		title: 'Help',
		exact: true,
		icon: <HelpIcon />,
	},
	{
		component: SettingsPage,
		path: '/settings',
		title: 'Settings',
		exact: true,
		icon: <SettingsIcon />,
		permission: [Roles.ADMIN],
	},
];
